export default __webpack_public_path__ + "d13.png";